var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHedge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "22px",
    viewBox: "0 0 30 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heades-new-Copy",
    transform: "translate(-610.000000, -1582.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(611.000000, 1583.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-105",
    points: "3.5 1.56115723 3.5 17.1328125 26.289917 17.1328125"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-106",
    points: "7.3671875 13.5 9.6875 9.34698486 14.8949585 11.2683105 17.7 6.5 20.9 7.91473389 27.4140625 0.53515625"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-101",
    points: "24 14 27 17 24 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-101",
    transform: "translate(3.500000, 2.000000) scale(1, -1) rotate(90.000000) translate(-3.500000, -2.000000) ",
    points: "2 -1 5 2 2 5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHedge);
export default __webpack_public_path__ + "static/media/hedge.b50d7f7d665bd3d566d49e354a9c92bb.svg";
export { ForwardRef as ReactComponent };